import { useMemo } from 'react'

const useStyle = () => useMemo(
  () => ({
    wrapperBorder: { size: '1px', color: 'red' },
    wrapperPad: { horizontal: '6px', vertical: '8px' },
    wrapperFxMargin: {
      large: { vertical: 'medium' },
      other: { bottom: 'medium' },
    },
    containerPosition: { position: 'relative' },
    iconWrapperMinWidth: { minWidth: 34 },
    textWrapperPad: { left: 'small' },
    textFxSize: { large: '16px', other: '14px' },
    linkMarginTop: { top: 'small' },
    linkFxSize: { large: '14px', other: '12px' },
    linkViewCursor: {
      borderRight: '1px solid #E0E0E0',
      paddingRight: '8px',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    linkCursor: {
      paddingLeft: '8px',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }),
  [],
)

export default useStyle
